webpackJsonp([19,51,150,151,234,235,292],{

/***/ 1020:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-collapse', {
    attrs: {
      "open": false,
      "aria-id": "contentIdForA11y1"
    }
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "slot": "trigger",
      "aria-controls": "contentIdForA11y1"
    },
    slot: "trigger"
  }, [_vm._v("Click me!")]), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("\n                        Subtitle\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. "), _c('br'), _vm._v("\n                        Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. "), _c('br'), _vm._v("\n                        Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n                    ")])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1021:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isOpen: true
        };
    }
});

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('button', {
    staticClass: "button is-medium is-primary",
    attrs: {
      "aria-controls": "contentIdForA11y2"
    },
    on: {
      "click": function($event) {
        _vm.isOpen = !_vm.isOpen
      }
    }
  }, [_vm._v("\n                Toggle\n            ")])]), _vm._v(" "), _c('b-collapse', {
    staticClass: "panel",
    attrs: {
      "aria-id": "contentIdForA11y2",
      "open": _vm.isOpen
    },
    on: {
      "update:open": function($event) {
        _vm.isOpen = $event
      }
    }
  }, [_c('div', {
    staticClass: "panel-heading",
    attrs: {
      "slot": "trigger",
      "role": "button",
      "aria-controls": "contentIdForA11y2"
    },
    slot: "trigger"
  }, [_c('strong', [_vm._v("Title")])]), _vm._v(" "), _c('p', {
    staticClass: "panel-tabs"
  }, [_c('a', {
    staticClass: "is-active"
  }, [_vm._v("All")]), _vm._v(" "), _c('a', [_vm._v("Public")]), _vm._v(" "), _c('a', [_vm._v("Private")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-block"
  }, [_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. "), _c('br'), _vm._v("\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. "), _c('br'), _vm._v("\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            ")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-collapse', {
    staticClass: "card",
    attrs: {
      "aria-id": "contentIdForA11y3"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function(props) {
        return _c('div', {
          staticClass: "card-header",
          attrs: {
            "role": "button",
            "aria-controls": "contentIdForA11y3"
          }
        }, [_c('p', {
          staticClass: "card-header-title"
        }, [_vm._v("\n                    Component\n                ")]), _vm._v(" "), _c('a', {
          staticClass: "card-header-icon"
        }, [_c('b-icon', {
          attrs: {
            "icon": props.open ? 'menu-down' : 'menu-up'
          }
        })], 1)])
      }
    }])
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.\n                    "), _c('a', [_vm._v("#buefy")]), _vm._v(".\n                ")])]), _vm._v(" "), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item"
  }, [_vm._v("Save")]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_vm._v("Delete")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1025);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(900)("4c9ea7b9", content, true);

/***/ }),

/***/ 1025:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(899)(true);
// imports


// module
exports.push([module.i, "\n.content[data-v-01310292] {\n        margin-bottom: 0 !important;\n}\n", "", {"version":3,"sources":["/root/Awesome-UI/buefy/docs/pages/components/collapse/examples/ExPosition.vue"],"names":[],"mappings":";AACA;QACQ,4BAA4B;CACnC","file":"ExPosition.vue","sourcesContent":["\n.content[data-v-01310292] {\n        margin-bottom: 0 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._m(0), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "open": false,
      "position": "is-bottom",
      "aria-id": "contentIdForA11y1"
    },
    scopedSlots: _vm._u([{
      key: "trigger",
      fn: function(props) {
        return _c('a', {
          attrs: {
            "aria-controls": "contentIdForA11y1"
          }
        }, [_c('b-icon', {
          attrs: {
            "icon": !props.open ? 'menu-down' : 'menu-up'
          }
        }), _vm._v("\n                " + _vm._s(!props.open ? 'All options' : 'Fewer options') + "\n            ")], 1)
      }
    }])
  }, [_c('p', [_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. "), _c('br'), _vm._v("\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. "), _c('br'), _vm._v("\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("\n                Subtitle\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. "), _c('br'), _vm._v("\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. "), _c('br'), _vm._v("\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            ")])])
}]}

/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            isOpen: 0,
            collapses: [{
                title: 'Title 1',
                text: 'Text 1'
            }, {
                title: 'Title 2',
                text: 'Text 2'
            }, {
                title: 'Title 3',
                text: 'Text 3'
            }]
        };
    }
});

/***/ }),

/***/ 1028:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', _vm._l((_vm.collapses), function(collapse, index) {
    return _c('b-collapse', {
      key: index,
      staticClass: "card",
      attrs: {
        "open": _vm.isOpen == index
      },
      on: {
        "open": function($event) {
          _vm.isOpen = index
        }
      },
      scopedSlots: _vm._u([{
        key: "trigger",
        fn: function(props) {
          return _c('div', {
            staticClass: "card-header",
            attrs: {
              "role": "button"
            }
          }, [_c('p', {
            staticClass: "card-header-title"
          }, [_vm._v("\n                    " + _vm._s(collapse.title) + "\n                ")]), _vm._v(" "), _c('a', {
            staticClass: "card-header-icon"
          }, [_c('b-icon', {
            attrs: {
              "icon": props.open ? 'menu-down' : 'menu-up'
            }
          })], 1)])
        }
      }])
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._v("\n                    " + _vm._s(collapse.text) + "\n                ")])])])
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ 1352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_collapse__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExPanelTemplate__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExPanelTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__examples_ExPanelTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExPanelTemplate__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExPanelTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExPanelTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExCardTemplate__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExCardTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__examples_ExCardTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExCardTemplate__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExCardTemplate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExCardTemplate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExPosition__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExPosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__examples_ExPosition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExPosition__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExPosition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExPosition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExAccordion__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExAccordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__examples_ExAccordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExAccordion__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExAccordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExAccordion__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_collapse__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_1__examples_ExSimple___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_2__raw_loader_examples_ExSimple___default.a,
            ExPanelTemplate: __WEBPACK_IMPORTED_MODULE_3__examples_ExPanelTemplate___default.a,
            ExPanelTemplateCode: __WEBPACK_IMPORTED_MODULE_4__raw_loader_examples_ExPanelTemplate___default.a,
            ExCardTemplate: __WEBPACK_IMPORTED_MODULE_5__examples_ExCardTemplate___default.a,
            ExCardTemplateCode: __WEBPACK_IMPORTED_MODULE_6__raw_loader_examples_ExCardTemplate___default.a,
            ExPosition: __WEBPACK_IMPORTED_MODULE_7__examples_ExPosition___default.a,
            ExPositionCode: __WEBPACK_IMPORTED_MODULE_8__raw_loader_examples_ExPosition___default.a,
            ExAccordion: __WEBPACK_IMPORTED_MODULE_9__examples_ExAccordion___default.a,
            ExAccordionCode: __WEBPACK_IMPORTED_MODULE_10__raw_loader_examples_ExAccordion___default.a
        };
    }
});

/***/ }),

/***/ 1353:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n\n        <b-collapse :open=\"false\" aria-id=\"contentIdForA11y1\">\n            <button\n                class=\"button is-primary\"\n                slot=\"trigger\"\n                aria-controls=\"contentIdForA11y1\">Click me!</button>\n            <div class=\"notification\">\n                <div class=\"content\">\n                    <h3>\n                        Subtitle\n                    </h3>\n                    <p>\n                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>\n                        Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. <br/>\n                        Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n                    </p>\n                </div>\n            </div>\n        </b-collapse>\n\n    </section>\n</template>\n"

/***/ }),

/***/ 1354:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n\n        <div class=\"block\">\n            <button\n                class=\"button is-medium is-primary\"\n                @click=\"isOpen = !isOpen\"\n                aria-controls=\"contentIdForA11y2\">\n                Toggle\n            </button>\n        </div>\n\n        <b-collapse\n                aria-id=\"contentIdForA11y2\"\n                class=\"panel\"\n                :open.sync=\"isOpen\">\n            <div\n                slot=\"trigger\"\n                class=\"panel-heading\"\n                role=\"button\"\n                aria-controls=\"contentIdForA11y2\">\n                <strong>Title</strong>\n            </div>\n            <p class=\"panel-tabs\">\n                <a class=\"is-active\">All</a>\n                <a>Public</a>\n                <a>Private</a>\n            </p>\n            <div class=\"panel-block\">\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. <br/>\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            </div>\n        </b-collapse>\n\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isOpen: true\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1355:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n\n        <b-collapse class=\"card\" aria-id=\"contentIdForA11y3\">\n            <div\n                slot=\"trigger\" \n                slot-scope=\"props\"\n                class=\"card-header\"\n                role=\"button\"\n                aria-controls=\"contentIdForA11y3\">\n                <p class=\"card-header-title\">\n                    Component\n                </p>\n                <a class=\"card-header-icon\">\n                    <b-icon\n                        :icon=\"props.open ? 'menu-down' : 'menu-up'\">\n                    </b-icon>\n                </a>\n            </div>\n            <div class=\"card-content\">\n                <div class=\"content\">\n                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus nec iaculis mauris.\n                    <a>#buefy</a>.\n                </div>\n            </div>\n            <footer class=\"card-footer\">\n                <a class=\"card-footer-item\">Save</a>\n                <a class=\"card-footer-item\">Edit</a>\n                <a class=\"card-footer-item\">Delete</a>\n            </footer>\n        </b-collapse>\n\n    </section>\n</template>\n"

/***/ }),

/***/ 1356:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"content\">\n            <h3>\n                Subtitle\n            </h3>\n            <p>\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. <br/>\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            </p>\n        </div>\n        <b-collapse :open=\"false\" position=\"is-bottom\" aria-id=\"contentIdForA11y1\">\n            <a slot=\"trigger\" slot-scope=\"props\" aria-controls=\"contentIdForA11y1\">\n                <b-icon :icon=\"!props.open ? 'menu-down' : 'menu-up'\"></b-icon>\n                {{ !props.open ? 'All options' : 'Fewer options' }}\n            </a>\n            <p>\n                Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>\n                Nulla accumsan, metus ultrices eleifend gravida, nulla nunc varius lectus, nec rutrum justo nibh eu lectus. <br/>\n                Ut vulputate semper dui. Fusce erat odio, sollicitudin vel erat vel, interdum mattis neque.\n            </p>\n        </b-collapse>\n    </section>\n</template>\n\n<style scoped>\n    .content {\n        margin-bottom: 0 !important;\n    }\n</style>"

/***/ }),

/***/ 1357:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n\n        <b-collapse\n            class=\"card\"\n            v-for=\"(collapse, index) of collapses\"\n            :key=\"index\"\n            :open=\"isOpen == index\"\n            @open=\"isOpen = index\">\n            <div\n                slot=\"trigger\"\n                slot-scope=\"props\"\n                class=\"card-header\"\n                role=\"button\">\n                <p class=\"card-header-title\">\n                    {{ collapse.title }}\n                </p>\n                <a class=\"card-header-icon\">\n                    <b-icon\n                        :icon=\"props.open ? 'menu-down' : 'menu-up'\">\n                    </b-icon>\n                </a>\n            </div>\n            <div class=\"card-content\">\n                <div class=\"content\">\n                    {{ collapse.text }}\n                </div>\n            </div>\n        </b-collapse>\n\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                isOpen: 0,\n                collapses: [\n                {\n                    title: 'Title 1',\n                    text: 'Text 1'\n                },\n                {\n                    title: 'Title 2',\n                    text: 'Text 2'\n                },\n                {\n                    title: 'Title 3',\n                    text: 'Text 3'\n                }\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1358:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExPanelTemplate,
      "code": _vm.ExPanelTemplateCode,
      "title": "Panel",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCardTemplate,
      "code": _vm.ExCardTemplateCode,
      "title": "Card",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExPosition,
      "code": _vm.ExPositionCode,
      "title": "Position",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExAccordion,
      "code": _vm.ExAccordionCode,
      "title": "Accordion Effect",
      "vertical": ""
    }
  }), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>open</code>',
        description: 'Whether collapse is open or not, use the .sync modifier to make it two-way binding',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>animation</code>',
        description: 'Custom animation (transition name)',
        type: 'String',
        values: '—',
        default: '<code>fade</code>'
    }, {
        name: '<code>aria-id</code>',
        description: 'Id for the container div. Should be used with aria-controls on trigger for better accessibility.',
        type: 'String',
        values: '—',
        default: ''
    }, {
        name: '<code>position</code>',
        description: 'Trigger position',
        type: 'String',
        values: '<code>is-top</code>, <code>is-bottom</code>',
        default: '<code>is-top</code>'
    }],
    slots: [{
        name: 'default',
        description: 'Content to show/hide',
        props: '—'
    }, {
        name: '<code>trigger</code>',
        description: 'Trigger content',
        props: '<code>open: Boolean</code>'
    }],
    events: [{
        name: '<code>open</code>',
        description: 'Triggers when user opened',
        parameters: '—'
    }, {
        name: '<code>close</code>',
        description: 'Triggers when user closed',
        parameters: '—'
    }],
    methods: [{
        name: '<code>toggle</code>',
        description: 'Toggle activation'
    }]
}]);

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1020),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1021),
  /* template */
  __webpack_require__(1022),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1023),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1024)
}
var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1026),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-01310292",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1027),
  /* template */
  __webpack_require__(1028),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1352),
  /* template */
  __webpack_require__(1358),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/19.cbb7cbb4d917d2a79d12.js